import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationModel } from 'src/app/core/models/regulation';
import { policyMappingDescription } from 'src/app/core/models/regulation/policy-Mapping-Description-Model';
import { DescriptionModel, MatchPoliciesModel, mappingPolicyModel, policyMappingData } from 'src/app/core/models/regulation/policy-Mapping-model';
import { UserProfile } from 'src/app/core/models/user';
import { RegulationService } from 'src/app/core/services/regulation';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { PolicyMappingDescriptionComponent } from '../policy-mapping-description/policy-mapping-description.component';
import { MatDialog } from '@angular/material/dialog';
import { AddChat, AttachmentMD5Request, AttachmentProcessingResponse, ChatRequest, ChatResponse, DeleteDocumentDto, ExtractedMSGDOCX, GetDocumentDto, QuestionResponse, UploadResponse, UrlUploadRequest } from 'src/app/core/models/rig-model/file-upload';
import { RigService } from 'src/app/core/services/rig/rig.service';
import { AttachmentDetails, ChatHistoryDetail, UpdateExtractedRigFile, UserChatDetail } from 'src/app/core/models/rig-model/user-chat-detail';
import { catchError, switchMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-change-viewer-regulatory',
  templateUrl: './change-viewer-regulatory.component.html',
  styleUrls: ['./change-viewer-regulatory.component.scss']
})
export class ChangeViewerRegulatoryComponent {

  //Input variables from ChangeViewerAnalyticComponent
  @Input() updatedDbId: number = 0;
  @Input() userJurisdiction: Array<ItemIdModel> = [];
  @Input() user: UserProfile | undefined;
  @Input() regulation: RegulationModel = new RegulationModel();

  //Mapping Old Vaiables as in ChangeViewerRigComponent
  mappingLoading = false;
  policyMappingData: policyMappingData = new policyMappingData();
  policyMappingDescription: policyMappingDescription[] = [];
  linkedDocumentsArray: { link: string, isChecked: boolean }[] = [];
  linkList: string[] = [];
  matchPoliciesInput: MatchPoliciesModel = new MatchPoliciesModel();
  selectLeftTabIndex: number = 0;
  isDescriptionView = true;
  isDocumentView = false;
  jurisdictionName: string = "";
  policiesDescriptionModel: DescriptionModel[] = [];
  selectedDescriptionId: number[] = [];
  pdfContent: string | ArrayBuffer | Uint8Array | undefined;
  selectedLinkedDocuments: string[] = [];
  isShowMappedRegulatory = false;
  matchPolicies: mappingPolicyModel[] = [];
  //For PDF
  page: number = 1;
  totalPages: number = 0;
  isLoaded: boolean = false;
  previewVisible: boolean = false;
  zoomLevel: number = 1;
  // Rig
  isCollapse: boolean = false;
  isProcessed: boolean = false;
  isProcessingStarted: boolean = true;
  suggestQuestion: boolean = false;
  userInput: string = '';
  documentDetail: GetDocumentDto[] = [];
  currentChatUuid: string = "";
  messages: ChatResponse[] = [];
  isReplyLoading: boolean = false;
  dialogue: boolean = false;
  isLinkClicked: boolean = false;
  isDocTextClicked: boolean = false;
  docText: string = "";
  docTextName: string = "";
  userChatList: UserChatDetail = new UserChatDetail();
  userChatDetails: ChatHistoryDetail = new ChatHistoryDetail();
  uploadHyperLinkList: string[] = [];
  hyperText: string = "";
  hyperLinkList: string[] = [];
  isPdf: boolean = false;
  isTxt: boolean = false;
  isDocx: boolean = false;
  userFirstName: string = "";
  userLastName: string = "";
  isLoading: boolean = false;
  azureContainername: string = "";
  @ViewChild('fileInput')
  fileInput!: ElementRef;
  docFileName: string = "";
  toastViewModel: ToastViewModel = new ToastViewModel();
  isShowToast: boolean = false;
  isDownCollapse: boolean = true;
  isProgressBar: boolean = false;
  isresponseOngoing = false;

  constructor(
    private regulationService: RegulationService,
    private userService: UserManagementService,
    public dialog: MatDialog,
    private rigService: RigService,
    private ref: ChangeDetectorRef,
    public _globalService: GlobalService
  ) { }

  ngOnInit() {
    const userName = this.user?.fullName;
    const parts = userName?.split(' ');
    if (parts) {
      this.userFirstName = parts[0];
      if (parts.length > 2) {
        this.userLastName = parts[2];
      } else {
        this.userLastName = parts[1];
      }
    }
    this.mappingLoading = true;
    this.regulationService.GetPolicyMappingRig(this.updatedDbId).subscribe((data: policyMappingData) => {
      if (data && data?.description) {
        this.policyMappingData = data;
        if (data.description) {
          this.policyMappingDescription = JSON.parse(data.description) as policyMappingDescription[];
        }
        if (data.linkedDocuments) {
          this.linkList = this.policyMappingData.linkedDocuments.split("|");
        }
      }
      this.mappingLoading = false;
      this.getCheckList(false);
    });
    this.matchPoliciesInput.updateModel.country = this.regulation.country;
    this.matchPoliciesInput.updateModel.geography = this.regulation.geography;
    this.matchPoliciesInput.updateModel.regulator = this.regulation.regulator;
    this.matchPoliciesInput.updateModel.title = this.regulation.title;
    this.matchPoliciesInput.updateModel.pubDate = this.regulation.date;
    this.matchPoliciesInput.updateModel.pubType = this.regulation.pubType;
    this.matchPoliciesInput.updateModel.hyperlink = this.regulation.hyperlink;
    this.matchPoliciesInput.updateModel.updatesId = this.updatedDbId;
    this.getStroedChatDetails();
    this.getAzureContainer();
    // this.startAttachmentProcess();
  }

  //Functions for Description and Document view same copied from ChangeViewerRigComponent
  leftTabMenuChanged(event: any): void {
    if (event.index == 0) {
      this.isDescriptionView = true;
      this.isDocumentView = false;
      this.getCheckList(true);
    }
    else if (event.index == 1) {
      this.isDescriptionView = false;
      this.isDocumentView = true;
    }
  }

  editButtonClick() {
    let description = "";
    let jurisdictionFilter = this.userJurisdiction.filter(x => x.id == this.user?.lastUsedJurisdictionId);
    if (jurisdictionFilter.length > 0) {
      this.jurisdictionName = jurisdictionFilter[0].name;
      let descriptionFilter = this.policyMappingDescription.filter(x => x.Jurisdiction == this.jurisdictionName);
      if (descriptionFilter.length > 0) {
        description = descriptionFilter[0].Description;
      }
    }
    const dialogRef = this.dialog.open(PolicyMappingDescriptionComponent, {
      width: '1000px',
      data: description
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const existingEntryIndex = this.policyMappingDescription.findIndex(
          entry => entry.Jurisdiction === this.jurisdictionName
        );
        if (existingEntryIndex !== -1) {
          // Update existing entry
          this.policyMappingDescription[existingEntryIndex].Description = result;
        } else {
          // Push new entry
          let ob = new policyMappingDescription();
          const maxId = this.policyMappingDescription.reduce((max, item) => {
            return item.Id > max ? item.Id : max;
          }, 0);
          ob.Id = maxId + 1;
          ob.Jurisdiction = this.jurisdictionName;
          ob.Description = result;
          ob.User = this.user?.fullName;
          this.policyMappingDescription.push(ob);
        }
        this.policyMappingData.description = JSON.stringify(this.policyMappingDescription);
        this.updatePolicyMapping();
      }
    });
  }

  updatePolicyMapping() {
    this.regulationService.UpdatePolicyMapping(this.policyMappingData).subscribe((data: any) => { });
  }

  addDescription(desc: policyMappingDescription, checked: boolean) {
    if (checked) {
      let descriptionModel = new DescriptionModel();
      descriptionModel.Description = desc.Description;
      descriptionModel.Jurisdiction = desc.Jurisdiction;
      descriptionModel.IsOriginal = desc.IsOriginal;
      descriptionModel.User = desc.User ? desc.User : null;
      this.policiesDescriptionModel.push(descriptionModel);
      this.selectedDescriptionId.push(desc.Id);
      this.docText = desc.Description;
      this.docTextName = desc.IsOriginal ? `Regulators Description_${this.regulation.id}` : `${desc.Jurisdiction}-${desc.User}_${this.regulation.id}`;
      this.uploadTXTFile();
    } else {
      const index = this.policiesDescriptionModel.findIndex(item => item.Description === desc.Description && item.Jurisdiction === desc.Jurisdiction);
      // If the description is found, remove it from the array
      if (index !== -1) {
        this.policiesDescriptionModel.splice(index, 1);
      }
      const idIndex = this.selectedDescriptionId.findIndex(item => item === desc.Id);
      if (idIndex !== -1) {
        this.selectedDescriptionId.splice(idIndex, 1);
      }
      let item;
      if (desc.IsOriginal) {
        item = this.documentDetail.find(item => item.documentName === `Regulators Description_${this.regulation.id}.txt`);
      } else {
        item = this.documentDetail.find(item => item.documentName === `${desc.Jurisdiction}-${desc.User}_${this.regulation.id}.txt`);
      }
      if (item) {
        this.removeDocument(item);
      }
    }
    this.matchPoliciesInput.descriptionModel = this.policiesDescriptionModel;
  }

  isPdfLink(link: string): boolean {
    return link.toLowerCase().endsWith('.pdf');
  }

  openPdf(link: string) {
    this.userService.generateJoseJWT("").subscribe((token: any) => {
      const myData = new UrlUploadRequest();
      myData.AzureContainerName = "oceandata";
      myData.ExternalUrl = link;
      this.rigService.getUrlOrFileFetchedData(token.message, myData).subscribe((result: UploadResponse) => {
        const myPdf = new GetDocumentDto();
        myPdf.containerName = "oceandata";
        myPdf.documentName = result.DisplayName;
        this.openDocument(myPdf);
      })
    })
  }
  addLinkedDocuments(link: string, checked: boolean) {
    if (checked) {
      this.selectedLinkedDocuments.push(link);
      this.hyperText = link;
      this.uploadHyperLinkList.push(this.hyperText);
      this.uploadHyperLinks();
    } else {
      this.selectedLinkedDocuments = this.selectedLinkedDocuments.filter(x => x != link);
      const item = this.documentDetail.find(item => item.link === link);
      if (item) {
        this.removeDocument(item);
      }
    }
    this.matchPoliciesInput.linkedDocuments = this.selectedLinkedDocuments.join('|');
  }
  getTooltipContent(suggestedName: string, source: string, page: string): any {
    const htmlContent = `
      <table>
        <thead>
          <tr>
            <th>Suggest Name</th>
            <th>Source</th>
            <th>Page</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${suggestedName}</td>
            <td>${source}</td>
            <td>${page}</td>
          </tr>
        </tbody>
      </table>
    `;
    const newString = `Suggest Name : ${suggestedName}\nSource : ${source}\nPage : ${page}`;
    const suggestedNameLine = `(Suggest Name) : ${suggestedName}`;
    const sourceLine = `(Source) : ${source}`;
    const pageLine = `(Page) : ${page}`;
    const tooltipContent = `${suggestedNameLine}      ${sourceLine}      ${pageLine}`;
    return tooltipContent;
  }
  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }
  nextPage() {
    this.page++;
  }
  prevPage() {
    this.page--;
  }
  onPageChanged(event: any) {
    this.page = event.page;
  }
  zoomIn() {
    this.zoomLevel += 0.1;
  }
  zoomOut() {
    this.zoomLevel -= 0.1;
  }
  //Rig
  getStroedChatDetails() {
    this.rigService.getUserChangeViewerChatDetails(this.user?.externalUserId, this.regulation.id.toString())
      .subscribe(res => {
        if (res) {
          this.isProcessingStarted = false;
          this.userChatDetails = res;
          if (res.chatHistory != null) {
            this.messages = [...JSON.parse(this.userChatDetails.chatHistory)];
            this.ref.detectChanges();
          }
          this.currentChatUuid = this.userChatDetails.uuid;
          if (this.userChatDetails.attachment != "" && this.userChatDetails.attachment != undefined) {
            const dataArray = JSON.parse(this.userChatDetails.attachment);
            this.documentDetail = dataArray?.map((item: any) => {
              const dto = new GetDocumentDto();
              dto.id = item.Id;
              dto.documentName = item.DisplayName;
              dto.containerName = item.AzureContainerName;
              dto.link = item.ExternalUrl;
              return dto;
            });
          }
        }
      });
  }
  getCheckList(isRemove: boolean) {
    this.documentChecked();
    if (isRemove) {
      this.linkChecked();
    } else {
      this.linkList.forEach(element => {
        let item = this.documentDetail.find(item => item.link === element);
        this.linkedDocumentsArray.push({
          link: element,
          isChecked: item ? true : false
        })
      });
    }
  }
  //Chat Messages region
  sendMessage() {
    if (this.documentDetail.length > 0) {
      if (this.userInput.trim() !== '') {
        this.suggestQuestion = false;
        let chat = new ChatRequest();
        chat.ChatUUID = this.currentChatUuid;
        chat.Question = this.userInput;
        this.messages.unshift({ content: this.userInput, role: "user", source: [] });
        this.messages.unshift({ content: "", role: "assistant", source: [] });
        this.isReplyLoading = true;
        this.userInput = '';
        this.sendChatRequestWithUpdate(chat);
        this._globalService.scrollSmoothToBottom('rigChatBox');
      }
    }
  }
  sendSuggestedMessage(message: string) {
    this.suggestQuestion = false;
    let chat = new ChatRequest();
    chat.ChatUUID = this.currentChatUuid;
    chat.Question = message;
    this.messages.unshift({ content: message, role: "user", source: [] });
    this.messages.unshift({ content: "", role: "assistant", source: [] });
    this.isReplyLoading = true;
    this.sendChatRequestWithUpdate(chat);
  }
  sendChatRequestWithUpdate(chat: ChatRequest) {
    this.userService.generateJoseJWT("").subscribe({
      next: (token: any) => {
        this.rigService.chatResponse(token.message, chat).subscribe({
          next: (response) => {
            this.isReplyLoading = false;
            this.isresponseOngoing = true;
            if (response.type === 'text') {
              this.messages[0].content += response.data;
            } else if (response.type === 'json') {
              this.isresponseOngoing = false;
              this.messages[0].role = response.data.role;
              this.messages[0].source = [...response.data.source];
              let chat = new AddChat();
              chat.chatDetails = JSON.stringify(this.messages);
              chat.uuid = this.currentChatUuid;
              this.rigService.addOrUpdateChat(chat).subscribe((res: any) => { });
            }
          }, error: (error) => {
            console.error('Error:', error);
          }, complete: () => {
          }
        });
      },
      error: (error) => {
        console.error('JWT error:', error);
      }
    });
  }
  //Chat Messages region
  documentDialogue() {
    this.dialogue = true
    this.isLinkClicked = false;
    this.isDocTextClicked = true;
  }
  linkDialogue() {
    this.dialogue = true;
    this.isDocTextClicked = false;
    this.isLinkClicked = true;
  }
  createAndUploadFile(): void {
    this.isLoading = true;
    if (this.isLinkClicked) {
      this.uploadHyperLink();
      this.dialogue = false;
    } else {
      this.uploadTXTFile();
    }
    this.isLoading = false;
  }
  uploadTXTFile() {
    this.isProgressBar = true;
    if (this.docText && this.docTextName) {
      const blob = new Blob([this.docText], { type: 'text/plain' });
      const textFile = new File([blob], `${this.docTextName}.txt`, { type: 'text/plain' });
      this.rigService.uploadRigFile(textFile, this.currentChatUuid, this.regulation.id.toString()).subscribe(
        (response: ExtractedMSGDOCX) => {
          const dto = new GetDocumentDto();
          dto.id = response.id;
          dto.documentName = response.displayName;
          dto.containerName = response.azureContainerName;
          this.documentDetail.push(dto);
          this.dialogue = false;
          this.userChatList.isActive = true;
          //CommentedOut S
          // if (!this.currentChatUuid) {
          //   this.getStroedChatDetails();
          // }
          //End
          this.getStroedChatDetails();
          this.docText = "";
          this.docTextName = "";
          this.isProgressBar = false;
          this.ref.detectChanges();
          if (dto) {
            this.documentChecked();
          }
        },
        (error: any) => {
          console.error('File upload error:', error);
        }
      );
      this.isProcessingStarted = false;
    }
  }
  documentChecked() {
    this.policyMappingDescription.map((x: policyMappingDescription) => {
      let item;
      if (x.IsOriginal) {
        item = this.documentDetail.find(item => item.documentName === `Regulators Description_${this.regulation.id}.txt`);
      } else {
        item = this.documentDetail.find(item => item.documentName === `${x.Jurisdiction}-${x.User}_${this.regulation.id}.txt`);
      }
      x.isChecked = item ? true : false;
    });
  }
  removeDocument(item: GetDocumentDto) {
    let documentDetails = new DeleteDocumentDto();
    documentDetails.uuid = this.currentChatUuid;
    documentDetails.AttachmentId = item.id;
    documentDetails.ContainerName = item.containerName;
    documentDetails.DisplayName = item.documentName;
    this.rigService.deleteExistingDocument(documentDetails).subscribe((res: any) => {
      this.documentDetail = this.documentDetail.filter(obj => obj.id !== item.id);
      this.getCheckList(true);
      this.ref.detectChanges();
    });
  }
  uploadHyperLink(): void {
    if (this.hyperText !== "" && this.hyperLinkList.length < 1) {
      this.uploadHyperLinkList.push(this.hyperText);
    }
    else if (this.hyperText !== "" && this.hyperLinkList.length > 0) {
      if (!this.hyperLinkList.includes(this.hyperText)) {
        this.addHyperLink();
      }
      this.uploadHyperLinkList = this.hyperLinkList;
    }
    else if (this.hyperText == "" && this.hyperLinkList.length > 0) {
      this.uploadHyperLinkList = this.hyperLinkList;
    }
    this.uploadHyperLinks();
  }
  addHyperLink() {
    if (this.hyperText !== "") {
      if (!this.hyperLinkList.includes(this.hyperText)) {
        this.hyperLinkList.push(this.hyperText);
        this.hyperText = "";
      } else {
        this.hyperText = "";
      }
    }
  }
  uploadHyperLinks() {
    this.isProgressBar = true;
    let requestData = new UpdateExtractedRigFile();
    if (this.uploadHyperLinkList.length > 0) {
      this.userService.generateJoseJWT("").pipe(
        switchMap((token: any) => {
          const observables = this.uploadHyperLinkList.map((str: string) => {
            const myData = new UrlUploadRequest();
            myData.AzureContainerName = "oceandata";
            myData.ExternalUrl = str;
            return this.rigService.getUrlOrFileFetchedData(token.message, myData).pipe(
              catchError(error => {
                console.error('Error for', str, ':', error);
                return of(null);
              })
            );
          });
          return forkJoin(observables);
        })
      ).subscribe((results: any) => {
        requestData.attachmentDetails = results.map((result: UploadResponse, index: number) => {
          if (result) {
            const attachment = new AttachmentDetails();
            attachment.azureContainerName = result.AzureContainerName;
            attachment.azureFileName = result.AzureFileName;
            attachment.displayName = result.DisplayName;
            attachment.externalUrl = this.uploadHyperLinkList[index];
            attachment.mD5 = result.MD5;
            attachment.globalAccess = true;
            attachment.updatesID = this.regulation.id;
            attachment.metadata = JSON.stringify(result.metadata);
            return attachment;
          }
          return null;
        }).filter((attachment: AttachmentDetails | null) => attachment !== null);
        requestData.uuid = this.currentChatUuid;
        requestData.changeViewerId = this.regulation.id;
        this.rigService.updateExtractedRigFile(requestData).subscribe((res: ChatHistoryDetail) => {
          const dataArray = JSON.parse(res.attachment);
          this.getStroedChatDetails();
          this.currentChatUuid = res.uuid;
          // let chatUuidIndex = this.userChatList.findIndex(a => a.uuid == this.currentChatUuid);
          // if (chatUuidIndex > -1) {
          //   this.userChatList[chatUuidIndex].isActive = true;
          //   this.ref.detectChanges();
          // }
          // else {
          //   this.getUserChatList(this.userDetails.externalUserId, () => {
          //     if (this.todayChats.length > 0) {
          //       this.currentChatUuid = this.todayChats[0].uuid;
          //       this.todayChats[0].isActive = true;
          //       this.getUserChatDetails(this.todayChats[0]);
          //     }
          //     this.ref.detectChanges();
          //   });
          // }
          this.isProgressBar = false;
          this.hyperLinkList = [];
          this.hyperText = "";
          this.uploadHyperLinkList = [];
          this.documentDetail = dataArray.map((item: any) => {
            const dto = new GetDocumentDto();
            dto.id = item.Id;
            dto.documentName = item.DisplayName;
            dto.containerName = item.AzureContainerName;
            dto.link = item.ExternalUrl;
            return dto;
          });
          if (dataArray) {
            this.linkChecked();
          }
        });
      });
      this.isProcessingStarted = false;
    } else {
      this.isProgressBar = true;
    }
  }
  linkChecked() {
    this.linkedDocumentsArray.map(element => {
      let item = this.documentDetail.find(item => item.link === element.link);
      element.isChecked = item ? true : false;
    });
  }
  openDocument(documentDetails: GetDocumentDto) {
    this.rigService.getDocument(documentDetails).subscribe((documentBlob: Blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const uint8Array = new Uint8Array(arrayBuffer);
        const chunkSize = 1024;
        let binaryString = '';
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
          const chunk = uint8Array.subarray(i, i + chunkSize);
          binaryString += String.fromCharCode.apply(null, Array.from(chunk));
        }
        const base64 = btoa(binaryString);
        const fileExtension = documentDetails.documentName.toLowerCase().split('.').pop();
        let contentType = '';
        switch (fileExtension) {
          case 'pdf':
            contentType = 'application/pdf';
            this.isPdf = true;
            this.isTxt = false;
            break;
          case 'txt':
            contentType = 'text/plain';
            this.isTxt = true;
            this.isPdf = false;
            break;
          default:
            console.error('Unsupported file type:', fileExtension);
            return;
        }
        this.pdfContent = `data:${contentType};base64,${base64}`;
      };
      reader.readAsArrayBuffer(documentBlob);
    });
    this.selectLeftTabIndex = 1;
    this.previewVisible = true;
    this.isDocumentView = true;
    this.isDescriptionView = false;
  }
  copyToClickboard(messages: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(messages).then(() => {
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    }
  }
  openFileInput() {
    this.fileInput.nativeElement.click();
  }
  // For Document file upload
  onFileSelected(event: any) {
    const selectedFile: File = event.target.files[0];
    let requestData = new UpdateExtractedRigFile();
    if (selectedFile) {
      this.isProgressBar = true;
      this.docFileName = selectedFile.name; // Get the filename
      this.rigService.uploadRigFile(selectedFile, this.currentChatUuid, this.regulation.id.toString()).subscribe(
        (res: ExtractedMSGDOCX) => {
          const fileObj = res;
          if (fileObj.fileType != "msg" && fileObj.fileType != "docx") {
            const dto = new GetDocumentDto();
            dto.id = fileObj.id;
            dto.documentName = fileObj.displayName;
            dto.containerName = fileObj.azureContainerName;
            dto.link = '';
            this.documentDetail.push(dto);
            //Commented S
            // if (!this.currentChatUuid) {
            //   this.getStroedChatDetails();
            // }
            //End
            this.getStroedChatDetails();
            this.successAlert("Provided Documents Uploaded Successfully.");
          } else {
            this.userService.generateJoseJWT("").subscribe((token: any) => {
              const myData = new UrlUploadRequest();
              myData.AzureContainerName = this.azureContainername;
              myData.ExternalUrl = "";
              myData.AzureFileName = fileObj.azureFileName;
              this.rigService.getUrlOrFileFetchedData(token.message, myData).subscribe((result: UploadResponse) => {
                const attachment = new AttachmentDetails();
                attachment.azureContainerName = this.azureContainername;
                attachment.azureFileName = result.AzureFileName;
                attachment.displayName = result.DisplayName;
                attachment.externalUrl = "";
                attachment.mD5 = result.MD5;
                attachment.globalAccess = false;
                attachment.updatesID = this.regulation.id;
                attachment.metadata = result.metadata;
                requestData.attachmentDetails.push(attachment);
                requestData.uuid = this.currentChatUuid;
                this.rigService.updateExtractedRigFile(requestData).subscribe((res: ChatHistoryDetail) => {
                  const dataArray = JSON.parse(res.attachment);
                  this.getStroedChatDetails();
                  this.currentChatUuid = res.uuid;
                  this.successAlert("Provided Documents Uploaded Successfully.");
                  this.documentDetail = dataArray.map((item: any) => {
                    const dto = new GetDocumentDto();
                    dto.id = item.Id;
                    dto.documentName = item.DisplayName;
                    dto.containerName = item.AzureContainerName;
                    dto.link = '';
                    return dto;
                  });
                });
              });
            });
          }
          this.isProcessingStarted = false;
          this.isProgressBar = false;
        },
        (error: any) => {
          this.toastViewModel.Title = 'warning';
          this.toastViewModel.Type = 'warning';
          this.toastViewModel.Message = error.error;
          this.isShowToast = true;
          setTimeout(() => {
            this.isShowToast = false;
          }, 3000);
          this.isProgressBar = false;
        }
      );
    }
  }
  successAlert(text: string): void {
    this.toastViewModel.Title = 'Success';
    this.toastViewModel.Type = 'success';
    this.toastViewModel.Message = text;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }
  getAzureContainer() {
    let sourceFolderName = "rig";
    this.rigService.getAzureContainerName(sourceFolderName).subscribe((res: any) => {
      this.azureContainername = res.result;
    });
  }
  downCollapse() {
    if (this.suggestedQuestions.length > 0) {
      this.isDownCollapse = !this.isDownCollapse;
    }
  }
  suggestedQuestions: Array<string> = [];
  startAttachmentProcess() {
    this.isProcessed = true;
    if (this.messages.length <= 0) {
      this.suggestQuestion = true;
    }
    const dataArray = JSON.parse(this.userChatDetails.attachment);
    this.userService.generateJoseJWT("").subscribe((token: any) => {
      this.rigService.attachmentProcessing(token.message, dataArray).subscribe((res: Array<AttachmentProcessingResponse>) => {
        let attachmentResponse = res;
        let attachmentRequest = new AttachmentMD5Request();
        attachmentRequest.attachment = JSON.stringify(attachmentResponse);
        attachmentRequest.uuid = this.currentChatUuid;
        this.rigService.updateMd5InAttachment(attachmentRequest).subscribe((res: any) => {
          const newDataArray = JSON.parse(res.result);
          this.rigService.getContextualQuestions(token.message, newDataArray).subscribe((resQues: QuestionResponse) => {
            this.suggestedQuestions = [...resQues.Questions];
            this.isDownCollapse = false;
            this.ref.detectChanges();
            this.isProcessed = false;
            // this.showSuggestions = true;

          });
        })

      });
    });
  }
}
